var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CanvasTexture, LinearFilter, Material, MeshBasicMaterial, SRGBColorSpace, Texture } from "three";
import { MeshRenderable } from "../mesh/MeshRenderable";
import { FacetRenderer, isRenderableType, Renderable, RenderableUpdateTriggerState } from "../renderable/Renderable";
const IMAGE_NOT_FOUND_FILE = "img/FlaVR_Final_Blue.png";
const texureNotFoundImage = new Image();
texureNotFoundImage.src = IMAGE_NOT_FOUND_FILE;
const textureNotFound = new Texture(texureNotFoundImage);
texureNotFoundImage.onload = () => {
    textureNotFound.needsUpdate = true;
};
export class PdfToTextureRenderable extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.owner = owner;
        this.canvas = document.createElement("canvas");
        this.canvasContext = this.canvas.getContext("2d");
        this.texture = new CanvasTexture(this.canvas);
        this.material = new MeshBasicMaterial({ map: this.texture });
        this.texture.colorSpace = SRGBColorSpace;
        this.texture.minFilter = LinearFilter;
    }
    destroy() {
        this.material.dispose();
    }
    setVisible(visible) {
        this.material.visible = visible;
        this.material.needsUpdate = true;
    }
    onInit(facet) {
        this.facet = facet;
        this.applyTextureToRenderable();
        this.facet = undefined;
    }
    snapshot(filename) {
        return __awaiter(this, void 0, void 0, function* () {
            const blob = yield new Promise((resolve) => {
                this.canvas.toBlob(resolve);
            });
            if (!blob) {
                throw new Error("Can't convert canvas to blob");
            }
            return new File([blob], filename, { type: "image/png" });
        });
    }
    updateFacet(facet) {
        return __awaiter(this, void 0, void 0, function* () {
            let texture;
            try {
                if (this.canvasContext == null)
                    return;
                const oldLoadingUrl = this.facet ? this.facet.url : undefined;
                if (!this.pdf) {
                    return;
                }
                const oldPage = this.facet ? this.facet.page : undefined;
                const page = yield this.pdf.getPage(facet.page || 1);
                if (oldLoadingUrl !== (this.facet ? this.facet.url : undefined) || oldPage !== (this.facet ? this.facet.page : undefined)) {
                    return;
                }
                const viewport = page.getViewport({ scale: 3 });
                const pw = viewport.width;
                const ph = viewport.height;
                texture = this.texture;
                this.canvas.width = pw;
                this.canvas.height = ph;
                const renderTask = page.render({
                    canvasContext: this.canvasContext,
                    viewport
                });
                yield renderTask.promise;
                if (oldLoadingUrl !== (this.facet ? this.facet.url : undefined) || oldPage !== (this.facet ? this.facet.page : undefined)) {
                    return;
                }
            }
            catch (error) {
                console.error("Error loading PDF", facet.url, error);
                texture = textureNotFound;
            }
            this.material.transparent = texture == textureNotFound;
            this.material.map = texture;
            texture.needsUpdate = true;
            this.material.needsUpdate = true;
        });
    }
    updateTransform() { }
    onOtherRenderableChanged(state, renderable) {
        switch (state) {
            case RenderableUpdateTriggerState.Changed:
                if (renderable instanceof Renderable) {
                    this.applyTextureToRenderable();
                }
                break;
            case RenderableUpdateTriggerState.Destroyed:
                break;
        }
    }
    applyTextureToRenderable() {
        const renderable = this.owner.renderable;
        if (!renderable) {
            return;
        }
        if (isRenderableType(MeshRenderable, renderable)) {
            this.applyTextureToMesh(renderable);
        }
    }
    applyTextureToMesh(renderabel) {
        if (!this.facet) {
            return;
        }
        if (!renderabel.meshInstance.isLoaded) {
            return;
        }
        renderabel.meshInstance.traverseMaterial(Material, ({}, mesh) => {
            mesh.material = this.material;
        });
    }
}
